<script setup>
import { onMounted } from 'vue';

defineOptions({
  name: 'BlankCellViewer'
});

const props = defineProps({
  params: {
    type: Object
  }
});

onMounted(() => {
  props.params.eGridCell.style.pointerEvents = 'none'; // Makes the cell non-clickable
  props.params.eGridCell.style.backgroundColor = '#f7f7f7'; // Sets the background color to light gray
  props.params.eGridCell.style.borderBottom = '0'; // Removes the bottom border
  // props.params.eGridCell.style.marginBottom = '0'; // Removes the bottom margin
  // props.params.eGridCell.style.marginTop = '0'; // Removes the padding
  // props.params.eGridCell.style.lineHeight = '0'; // Removes the padding
});
</script>

<template>
  <div class="tw-hidden"></div>
</template>

<style scoped lang="css"></style>
